<template>
    <!-- Toast Message -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false" />

      <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-user-graduate text-primary"></i> Students</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
            </div>
        <div class="col-md-3">
          <label class="form-label">Section
            :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
            <div class="col-md-3">
          <label class="form-label">Gender :</label> 
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.gender">
            <option selected></option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
        <div class="col-md-9 text-end">
          <button class="btn btn-sm btn-success me-1" @click="save()">
            <i class="fa fa-search text-white me-1"></i>Go
          </button>
           <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
        <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      </div>
      <div class="row" v-if="tableshow">
        <div class="col-md-9 table-responsive mt-2">
         <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
         <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10" :exportExcel="true" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from '@/utils/validation.js';
import {  api } from '@/utils/helpers.js';
import { ref} from 'vue'
import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList } = schoolStore();
const  Obj = ref( { clsID: "", sectionID: "",  })
const   msgObj= ref({ msg: "", role: "", show: false, })
const   errors= ref({})
const tableshow = ref(false)
const cols=ref([
  { label: 'S.No', key: 'Sno' },
{ label: 'Photo', key: 'photo', type: 'image' },
  { label: 'Roll No', key: 'rollNo' },
  { label: 'Name', key: 'firstName' },
  { label: 'Class', key: 'cls' },
  { label: 'Gender', key: 'gender' },
   { label: 'DOB', key: 'dob' },
  { label: 'Father Name', key: 'fatherName' },
  { label: 'Mother Name', key: 'motherName' },
  { label: 'Mobile', key: 'phone' },
  { label: 'Category', key: 'category' },
  { label: 'Student Aadhaar', key: 'studentAadhar' },
  { label: 'Parent Aadhaar', key: 'parentAadhar' },
  { label: 'Address', key: 'address' }
]);
const rows=ref([])
    const reset= async() => {
      Obj.value = { clsID: "", sectionID: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
      tableshow.value=false;
    }
    const progress = ref(0)
const save = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);

  const fields = {
    Class: { value: Obj.value.clsID, validators: [isRequired] },
  };
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    try {
      let url = "";
      if (Obj.value.sectionID) {
        url = `/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`;
      } else {
        url = `/students/clssection/${Obj.value.clsID}/All`;
      }
      const response = await api.get(url);
      let data = response.data;
      if (Obj.value.gender) {
        data = data.filter(s => s.gender === Obj.value.gender);
      }
      rows.value = data.map((item, i) => ({
        ...item,
        Sno: i + 1,

photo: item.image || '',

dob: item.dob
  ? new Date(item.dob).toISOString().slice(0, 10)
  : '',


  fatherName: item.parent?.fatherName || '',
  motherName: item.parent?.motherName || '',
  phone: item.parent?.phone || '',
  category: item.parent?.category?.Name || '',
  studentAadhar: item.aadharNumber || '',
  parentAadhar: item.parent?.aadharNumber || '',
  address: item.parent?.address || '',
        gender: item.gender || "",
        cls: `${clsList.value.find(c => c._id === item.clsID)?.name || ""}${
          clsList.value.find(c => c._id === item.clsID)?.name
            ? secList.value.find(s => s._id === item.sectionID)?.Name
              ? " (" + secList.value.find(s => s._id === item.sectionID)?.Name + ")"
              : ""
            : ""
        }`,
      }));

      progress.value = 0;
      clearInterval(progressInterval);
      tableshow.value = true;
    } catch (err) {
      progress.value = 0;
      clearInterval(progressInterval);
      msgObj.value = { msg: "Error fetching students", role: "danger", show: true };
    }
  }
};
</script>
